/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect, useState } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { RootState, store } from "./app/store";
import { toast, ToastContainer } from "react-toastify";
import { routes } from "./utils/data/routes";
// import { getMessaging, getToken }from "firebase/messaging";
// import io, { Socket } from 'socket.io-client';
import "./assets/css/globalStyle.scss";
import "./assets/css/restaurant-portal/sign-in.scss";
import "./assets/css/restaurant-portal/sign-up.scss";
import "./assets/css/restaurant-portal/dashboard.order-management.scss";
import "./assets/css/restaurant-portal/dashboard.profile.scss";
import "./assets/css/restaurant-portal/dashboard.profile.edit.scss";
import "./assets/css/restaurant-portal/dashboard.reviews.scss";
import "./assets/css/restaurant-portal/dashboard.menu-manager.scss";
import "./assets/css/restaurant-portal/dashboard.add-menu.scss";
import "./assets/css/restaurant-portal/dashboard.acct-activation.scss";
import "./assets/css/restaurant-portal/dashboard.notification.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
// import PushNotification from "./components/notificationComponent/pushNotification";
// import { useLazyGetRefreshTokenQuery } from "./features/services/restaurant/service";
import axios from "axios";
import { setUser } from "./features/slice/restaurant/authSlice";
import {
  MDBBtn,
  MDBCollapse,
  MDBInput,
  MDBSpinner,
  // MDBSelect,
} from "mdb-react-ui-kit";

const router = createBrowserRouter(routes);
// Login details to test restaurant
//mlh36239@vogco.com
//Pa$$w0rd!

function AppWrapper() {
  const rToken = sessionStorage.getItem("PEAKREACH_REFRESH");
  const dispatch = useDispatch();

  const refetchToken = () => {
    try {
      axios
        .get(
          `
        ${process.env.REACT_APP_BACKEND_BASE_URL}/restaurants/refresh-token`,
          { headers: { Authorization: `Bearer ${rToken}` } }
        )
        .then((res) => {
          dispatch(
            setUser({
              token: res.data.token,
              message: "token refetch successful",
            })
          );
        });
    } catch (err) {}
  };

  useEffect(() => {
    // Call the function immediately when the component mounts

    // Set up an interval to call the function every 1 hour (3600000 milliseconds)
    const intervalId = setInterval(() => {
      refetchToken();
    }, 3600000);

    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <AppWrapper />
      </Provider>
      <ToastContainer hideProgressBar={true} position="top-right" />
      {/* <PushNotification /> */}
    </React.StrictMode>
  );
}

export default App;
